// CRA/webpack substitui process.env.VAR por string literal no build — seguro no browser.
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.1'
